<template>
    <div>
        <FilterBadges :badges="filterBadges" class="mb-1"></FilterBadges>
        <v-row dense>
            <v-col v-for="kpi in kpis" :key="kpi.title" cols="12" sm="4">
                <StatCard :tone="kpi.tone" :icon="kpi.icon" :title="kpi.title" :value="kpi.value"
                    :description="kpi.description" :loading="loading"></StatCard>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="12" md="8">
                <GraficaSalidas title="Venta (Pzas)" :labels="ventaByDay.labels" :datasets="ventaByDay.datasets"
                    :loading="loading" :error="error"></GraficaSalidas>
            </v-col>
            <v-col cols="12" md="4">
                <ChartPanel title="Venta por producto" type="doughnut" :labels="ventaByProduct.labels"
                    :data="ventaByProduct.data" label="Piezas" :loading="loading" :error="error" height="280px">
                </ChartPanel>
            </v-col>
            <v-col cols="12" :md="allBranches ? 6 : 12">
                <GraficaSalidas title="Ventas vs merma (Pzas)" :labels="lossVsSales.labels" :datasets="lossVsSales.datasets"
                    :loading="loading" :error="error"></GraficaSalidas>
            </v-col>
            <v-col v-if="allBranches" cols="12" md="6">
                <GraficaSalidas title="Ventas vs merma por sucursal (Pzas)" :labels="byBranch.labels"
                    :datasets="byBranch.datasets" :toggle="false" :loading="loading" :error="error"></GraficaSalidas>
            </v-col>
            <v-col cols="12">
                <GraficaSalidas title="Merma (Pzas)" :labels="mermaByDay.labels" :datasets="mermaByDay.datasets"
                    :loading="loading" :error="error"></GraficaSalidas>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import StatCard from '@/components/shared/StatCard.vue';
import DashboardDataService from '@/service/dashboard/DashboardDataService';
import { dashboardFilterMixin, dashboardRangeMixin, dashboardWidgetMixin } from '@/mixins/dashboardWidgetMixin';
import ChartPanel from './ChartPanel.vue';
import FilterBadges from './FilterBadges.vue';
import GraficaSalidas from './GraficaSalidas.vue';
import { piecesByDay, piecesByProduct, salesVsLoss, salesVsLossByBranch, sumPieces } from './dashboardData';

/**
 * Piezas del periodo: vendidas, de merma y % de merma, más las gráficas por día y por producto. Salen de
 * `api/v1/dashboard/piezas`, que respeta el rango de fechas y la sucursal del usuario (el endpoint anterior,
 * `ventaDetalle/graficaVenta`, solo traía la semana en curso y los días como nombre, no como fecha).
 */
export default {
    name: 'GraficaVenta',
    components: { ChartPanel, FilterBadges, GraficaSalidas, StatCard },
    mixins: [dashboardWidgetMixin, dashboardRangeMixin, dashboardFilterMixin],
    filterScope: { sucursal: true, producto: true },
    props: {
        // CAP.DASHBOARD_TODAS_SUCURSALES_VER: solo entonces hay comparativo por sucursal (el backend no lo manda al resto).
        allBranches: { type: Boolean, default: false }
    },
    data() {
        return { data: null };
    },
    computed: {
        lossVsSales() {
            return salesVsLoss(this.ventaRows, this.mermaRows, this.week);
        },
        byBranch() {
            const d = this.data || {};
            return salesVsLossByBranch(d.ventasPorSucursal, d.mermaPorSucursal);
        },
        ventaRows() {
            return this.data ? this.data.ventas : [];
        },
        mermaRows() {
            return this.data ? this.data.merma : [];
        },
        ventaByDay() {
            return piecesByDay(this.ventaRows, this.week);
        },
        ventaByProduct() {
            return piecesByProduct(this.ventaRows);
        },
        mermaByDay() {
            return piecesByDay(this.mermaRows, this.week);
        },
        kpis() {
            const sold = sumPieces(this.ventaRows);
            const lost = sumPieces(this.mermaRows);
            const pct = sold + lost > 0 ? ((lost / (sold + lost)) * 100).toFixed(1) : '0.0';
            const show = (value) => (this.error ? null : value);
            return [
                { title: 'Piezas vendidas', value: show(sold), tone: 'success', icon: 'fas fa-box', description: '' },
                { title: 'Piezas de merma', value: show(lost), tone: 'warning', icon: 'fas fa-triangle-exclamation', description: '' },
                { title: '% de merma', value: show(`${pct}%`), tone: 'neutral', icon: 'fas fa-percent', description: '' }
            ];
        }
    },
    created() {
        this.reload();
    },
    methods: {
        reload() {
            return this.loadWidget(() => DashboardDataService.piezas(this.startNatural, this.endNatural, this.filters), (data) => {
                this.data = data;
            });
        }
    }
};
</script>
